import { CardBody, Collapse } from "reactstrap";
import { Image, P } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constant";
import { FRIENDS_DATA } from "../../../../../Data/SocialApp";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { MyProfileClassCollapseProp } from "../../../../../Type/SocialAppType";
 
const ActivityFeedCollapse = ({ isFilter }: MyProfileClassCollapseProp) => {
  return (
    <Collapse isOpen={isFilter}>
      <CardBody className="social-status filter-cards-view">
        {FRIENDS_DATA.map((data, index) => (
          <div className="d-flex" key={index}>
            <Image className="img-50 rounded-circle m-r-15" src={dynamicImage(`user/${data.imageName}`)} alt="user"/>
            <div className="flex-grow-1">
              <span className="f-w-600 d-block">{data.title}</span>
              <P>Commented on Shaun Park's <a href={Href}>Photo</a></P>
              <span className="light-span">{data.time} Ago</span>
            </div>
          </div>
        ))}
      </CardBody>
    </Collapse>
  );
};

export default ActivityFeedCollapse;
